import { Navigate, Route, useLocation, useParams } from 'react-router-dom'

import { LEGACY_ADMIN_REDIRECTS } from './legacyAdminRedirectTable'

/** #1331 Part 1c — old Email admin URLs redirect to their Communication home, slug and query preserved. */

function RedirectTo({ to }: { to: string }) {
  const { slug } = useParams()
  const { search } = useLocation()
  const target = slug ? `${to}/${encodeURIComponent(slug)}` : to
  return <Navigate replace to={`${target}${search}`} />
}

/** Route elements to drop inside the app's <Routes>. */
export function LegacyAdminRedirectRoutes() {
  return LEGACY_ADMIN_REDIRECTS.flatMap(({ from, to }) => [
    <Route key={from} path={from} element={<RedirectTo to={to} />} />,
    <Route key={`${from}/:slug`} path={`${from}/:slug`} element={<RedirectTo to={to} />} />,
  ])
}
